import React, { Component } from 'react';
import NewAccountFormPage from './views/pages/NewAccountForm.Page';
type AppProps = {
  formID: string;
}



export default class App extends Component<AppProps> {
  constructor(props: AppProps) {
    super(props);
  }

  public render() {
    return (
      <>
        {
          <NewAccountFormPage formID={this.props.formID} />
        }
      </>
    );
  }
}